/* eslint-disable indent */
/* eslint-disable max-len */
import React, { useCallback, useEffect,useState,useContext } from "react"
import TopHeader from "../../../components/TopHeader"
import { motion } from 'framer-motion'
import { Link } from "react-router-dom"
import { useParams,useLocation,useNavigate,useSearchParams } from "react-router-dom"
import { useDispatch, useSelector} from 'react-redux'
import CustomOverLay from "../../../components/CustomOverLay"
import GlobalContext from "../../../components/Context/GloablContext"
import SearchEmptyScreen from "../../../components/SearchEmptyScreen"
import { useExportPatientNotesMutation, useViewPatientQuery } from "../../../features/patientSlice"
import ViewPatientDetails from "./Components/ViewPatientDetails"
import ViewMonitorConditionTemplate from "../../ManageMonitoringConditionsTemplates/viewMonitotingTemplate"
import ViewAdministartiveDetails from "./Components/ViewAdministrativeNotes"
import ViewMedicalNoteDetails from "./Components/ViewMedicalNotes"
import ViewPatientDevices from "./Components/ViewPatientDevices"
import { handleSidebarAnimation } from "../../../redux/commonSlice"
import { handleEditMessageSent } from "../../../redux/systemConfigSlice"
import HelpGuideModal from "../../../components/HelpGuideModal"
import {useGetHelpGuideAdminQuery} from '../../../features/patientSlice'
import { resetPatientSearch } from "../../../redux/patientSearchSlice"
import { resetDeviceAlertDashboardSearch } from "../../../redux/deviceAlertDashboardSlice"
import { openExportTab, trackLargeExport } from '../../../CommonMethods/LargeExport'

export default function ViewPatient({isDashboard,isOrganization,patient_id,patientID}){
    const { setToastmessage,setToastErrorMessage,sendMessageToStartEditing,editSocket,setIsAdvancedSearchOpen } = useContext(GlobalContext)
    const navigate=useNavigate()
    const [searchParams,setSearchParams] =useSearchParams()
    const {isSideBar} = useContext(GlobalContext)
    const location=useLocation();
    const viewId = useSelector((state)=>state?.systemConfigData?.viewToUser)
    const auth=useSelector(state=>state?.auth)
    const [patientTabName,setPatientTabName]= useState('patient')
    const [notedetails,setViewNoteDetails]=useState([]);
    const [medicalNotes,setViewMedicalDetails]=useState([])
    const [exportNotes]=useExportPatientNotesMutation()
    const messageSent = useSelector(state=>state?.systemConfigData?.messageSent)
    const dateformat=useSelector(state=>state?.systemConfigData?.globalVariables?.date_format)
    const [exportLoading,setExportLoading]=useState(false)
    const dispatch = useDispatch()
    const {id}=useParams()
    let view=true
    const viewIdpatient = location.state?.viewId; 
    const {data,isFetching,status}=useViewPatientQuery(isOrganization===undefined?`${id}?action=view`:`${patient_id}?action=view&capture=true`, {refetchOnMountOrArgChange: true})
       
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsadmin, setQueryParamsadmin] = useState('')
    const userType=localStorage?.getItem('user_type')!==null?localStorage.getItem('user_type'):sessionStorage.getItem('user_type')
      
    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideAdminQuery(queryParamsadmin, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });
    const [notesCount,setNotesCount]=useState('0')
    
    
     useEffect(() => {
        if(isDashboard===undefined){
            if (userType === 'corporate-user') {
                setQueryParamsadmin('type=corporate-view-patients');
            } else {
                setQueryParamsadmin('type=admin-view-patients');
            }
        }else{
            if (userType === 'corporate-user') {
                setQueryParamsadmin('type=corporate-dashboard-view-patients');
            } else {
                setQueryParamsadmin('type=corporate-dashboard-view-patients');
            }
        }
       
    }, [userType]);
      
    useEffect(() => {
        if (queryParamsadmin) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsadmin]);

      useEffect(()=>{
         if(Array.isArray(location.state)&&location?.state?.length===1&&(!location?.state?.[0]?.includes('@'))){
              handleTabChange(location?.state?.[0])
              navigate({
                state: {}
              });
         }
         else if(Array.isArray(location.state)&&location?.state?.length===2){
              handleTabChange(location?.state?.[0])
              navigate(location.pathname, { state: location.state[1], replace: true });
         }
      },[location])

      const handleSearchClose = () => {
        dispatch(resetPatientSearch()),
        dispatch(resetDeviceAlertDashboardSearch())
        setIsAdvancedSearchOpen(false) 
      }
    
      const handleEditButtonClick = (fromView,state) =>{
        if(!messageSent){
            sendMessageToStartEditing(data?.[0]?.patient_id)
            let message
            editSocket.onmessage = (event) =>{
                message = event.data
                if(JSON.parse(message)?.success_status===true && JSON.parse(message)?.message==='Success'){
                    if (params.view === undefined) {
                    navigate(`/manage-patients/edit-patients/${id}`,{state:fromView==='fromView'?state:[location.state,true,id]})
                    handleSearchClose();
                    }
                    else{
                        navigate(`/manage-patients/edit-patients/${ data?.[0]?._id}`, { state: { viewId: data?.[0]?._id } });
                        handleSearchClose();
                        // navigate(`/manage-patients/edit-patients/${viewIdpatient}`,{state:fromView==='fromView'?state:[location.state,true,]})
                    }
                } else{
                    dispatch(handleEditMessageSent(false))
                    { (JSON.parse(message)?.adminId) &&
                        setToastErrorMessage(`A user with username ${decodeURIComponent( JSON.parse(message)?.adminId)} is already editing this patient`)
                    }
               
                }
            }    
        }
    }   
    
    const handleTabChange=(tabName, nextState=location.state, replace=false)=>{
        setPatientTabName(tabName)
        // Reset pagination to default values when changing tabs
        const currentParams = Object.fromEntries(searchParams);
        setSearchParams({
            ...currentParams,
            tab: tabName,
            page_number: 1,
            limit: 15
        }, { state: nextState, replace });
    }

    const handleGobackFn = () =>{
        let params = Object.fromEntries(searchParams);
        params['view']!==null && delete params['view']
        setSearchParams({ ...params})
    }


    //Administrative & Medical Notes Export
    async function handleExport(type){
        let patientId=data[0].patient_id
        let noteType=type
        setExportLoading(true)

        let payload ={patientId,dateformat,noteType}
        const exportTab = openExportTab(notesCount)
        const exportRes=await exportNotes(payload)
        setExportLoading(false)
        if (!trackLargeExport(exportRes?.data, { exportTab, setToastmessage, setToastErrorMessage })) {
            window.open(exportRes?.data.presigned_url)
        
            if(exportRes?.error){
                setToastErrorMessage("Something went wrong")
            }
            else{
                setToastmessage(exportRes?.data?.message)   
            }   
        }
    }

    const [isSafari, setIsSafari] = useState(false);

    useEffect(() => {
        setIsSafari(/^((?!chrome|firefox|android).)*safari/i.test(navigator.userAgent));
    }, []);

    useEffect(()=>{
        // 'vital_screen'/'device_screen' are legacy aliases sent by the Reading/Vital History
        // screens; the other sub-screens send a real tab name directly.
        const TAB_NAMES=['patient','monitoring_conditions','device_details','administrative_notes','medical_notes']
        const rawHint=location.state?.tab_hint
        const tabHint=TAB_NAMES.includes(rawHint) ? rawHint
            : rawHint==='vital_screen' ? 'monitoring_conditions'
                : rawHint==='device_screen' ? 'device_details'
                    : undefined
        if(!tabHint) return
        // Drop the hint before rewriting the URL. Keeping it would make this effect fire again on
        // the resulting location and navigate forever — Firefox rate-limits history calls and
        // throws SecurityError, which surfaces as the "Something went wrong" error boundary.
        const {tab_hint,...restState}=location.state
        handleTabChange(tabHint,restState,true)
    },[location])

    let params=Object.fromEntries(searchParams)

    return(
        <>
            <div id={"patient_main_div"} className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden'>
                <TopHeader title={isDashboard!==undefined?"Dashboard":isOrganization===undefined?"Manage Patients":isOrganization===true&&'Manage Organizations'}/>
                {/* isFetching&&status!=="fulfilled" */}
                {isFetching&&status!=="fulfilled"?<CustomOverLay Active text="Loading Patient Details..." classKey={`absolute top-0 left-0 z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${isSideBar?'opened-sidebar-config':'system_config_overlay'}`}/>:status==="rejected"?<SearchEmptyScreen text={"No data found"} />:<>

                    <div className='bg-white rounded-lg py-[12px] px-[30px] h-customh3'>
                        <motion.div 
                            className="mt-1"
                            animate={{ x: 0 }}
                            initial={{ x: -10 }}
                            transition={{duration:0.5}}
                        >
                            <div className='bg-white'>
                                <div className='flex items-center justify-start  mb-[22px]'>
                                    {isDashboard!==undefined?<div className="flex items-center w-full justify-between ml-[28px]">
                                        <div className="flex justify-start">
                                            <Link to={("/dashboard")} onClick={()=>dispatch(handleSidebarAnimation(false))} state={Array.isArray(location.state)?'':location.state}>
                                                <h1 className="text-sm font-normal text-[#52555D]">List of Alerts</h1>
                                            </Link>
                                            <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon"/></span>
                                            <button onClick={handleGobackFn}>
                                                <h1 className="text-sm font-normal text-[#52555D]">View Patient</h1>
                                            </button>
                                            <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon"/></span>
                                            <h1 className="text-sm font-normal text-[#008586]">View Patient Details</h1>

                                        </div>
                                        
                                        <div className="flex justify-end">
                                            {
                            userType !=='super-admin' &&
                            <span   onClick={() => setHelpGuideModel(true)} className='ml-auto mr-9 cursor-pointer'>
                                <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                            </span> 
                        }

                                        </div>
                                       
                                    </div>:isOrganization===undefined?<>
                                        <Link to="/manage-patients" state={Array.isArray(location.state)?(location.state[1]??''):location.state}>
                                            <h1 className="text-sm font-normal text-[#52555D]">List of Patients</h1>
                                        </Link>
                                        <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon"/></span>
                                        <h1 className="text-sm font-normal text-[#008586]">View Patient</h1>
                                        {
                            userType !=='super-admin' &&
                            <span   onClick={() => setHelpGuideModel(true)} className='ml-auto min-w-fit cursor-pointer'>
                                <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                            </span> 
                        }
                                    </>:isOrganization===true&&<>
                                        <Link to="/manage-organizations">
                                            <h1 className="text-sm font-normal text-[#52555D]">List of Organizations</h1>
                                        </Link>
                                        <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon"/></span>
                        
                                        {viewId!==""&&<>
                                            <Link to={`/manage-organizations/${viewId}`}>
                                                <h1 className="text-sm font-normal text-[#52555D]">View Organization</h1>
                                            </Link>
                                            <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon"/></span>
                                            </>} 
                                        <button onClick={handleGobackFn}>
                                            <h1 className="text-sm font-normal text-[#52555D]">List of Patients</h1>
                                        </button>
                                        <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon"/></span>
                                        <h1 className="text-sm font-normal text-[#008586]">View Patient</h1>
                                        {
                                            userType !=='super-admin' &&
                                            <span   onClick={() => setHelpGuideModel(true)} className='ml-auto min-w-fit cursor-pointer'>
                                                <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                                            </span> 
                                        }
                                    </>}
                                </div>
                                <div className="flex items-center pb-3 pr-9">
                                    {isDashboard===undefined&&isOrganization===undefined?<Link to={`/manage-patients`} state={Array.isArray(location.state)?(location.state[1]??''):location.state} className='flex items-center min-w-max z-[99]'>
                                        <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                                        <span className='text-sm font-normal text-[#008586] ml-3'>Go back to Listing</span>
                                    </Link>:isDashboard===undefined&&<button onClick={handleGobackFn} className='flex items-center min-w-max z-10'> 
                                        <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                                        <span className='text-sm font-normal text-[#008586] ml-3'>Go back to Listing</span>
                                    </button>}
                                    <h1 className={`text-xl font-normal text-[#000000] text-center w-full ${isDashboard==undefined&&'xl:-ml-[146px]'}`}>
                                        View Patient
                                    </h1>
                                    <div className="xl:hidden flex justify-start">
                                        <button 
                                            onClick={()=>{handleEditButtonClick('fromView',[location.state,"FromView",id,patientTabName])}} 
                                            id="edit" type='button' className={`min-w-max px-4 py-2 border border-[#972E4C] h-fit rounded-[16px] flex items-center ml-4`}>
                                            <span className='w-5'><img src="/images/edit_icon.svg" alt="icon"/></span>
                                            <span className='pl-2.5 text-lg font-normal text-[#972E4C]'>Edit</span>
                                        </button>
                                        <button type="button" id="welleness_check_resp"
                                            onClick={() => {
                                                    if (params.view === undefined) {
                                                        navigate(`/manage-patients/contact-history/${data[0]?.patient_id}`, { state: { ...(Array.isArray(location.state) ? {} : (location.state || {})), user_id: id, tab_hint: patientTabName } });
                                                        handleSearchClose();
                                                    } else {
                                                        navigate(`/manage-patients/contact-history/${patientID?.patient_id}`, { state: { ...(Array.isArray(location.state) ? {} : (location.state || {})), user_id: params.view, tab_hint: patientTabName } });
                                                        handleSearchClose();
                                                    }
                                                }}
                                            className={`py-2.5 px-4 flex items-center text-lg font-normal text-[#fff] 
                                        rounded-[16px] bg-[#972E4C] hover:bg-[#AB556E] min-w-max
                                            focus:bg-[#863B50] disabled:bg-[#777C88] ml-2 ${patientTabName==="administrative_notes" || patientTabName==="medical_notes" ? "xl:block hidden" : "block"}`}>
                                            Contact History
                                        </button>
                                    </div>
                                </div>
                                <div>
                                    <div className="flex justify-between items-center pl-[30px] xl:pr-11 pr-9">
                                        <div className="flex items-center">
                                            <p data-testid="patient-name" className="text-xl font-semibold text-[#000000]">{data[0]?.first_name || ''} {data[0]?.middle_name || ''} {data[0]?.last_name || ''}</p>
                                            <p data-testid="patient-view-id" className="text-sm font-normal text-[#000000] px-2">{data[0]?.patient_id}</p>
                                            {data[0]?.status=='inactive' ? <p className="px-3 py-1.5 bg-[#C5C9DA] rounded-[16px] text-sm font-semibold text-[#52555D]">Inactive</p> : 
                                            <p className="px-3 py-1.5 bg-[#CCE7E7] rounded-[16px] text-sm font-semibold text-[#006A6B]">Active</p>
                                            }
                                        </div>
                                        <div className="flex items-center">
                                            {patientTabName==="monitoring_conditions" &&
                                                <button type="button" id="welleness_check" data-testid={'vital-history'}
                                                    onClick={()=>{
                                                    if (params.view === undefined) {
                                                     navigate(`/manage-patients/${data?.[0]?._id}/vital-history/${data?.[0]?.patient_id}`, { state: [data[0], true, id, Array.isArray(location.state) ? '' : location.state] }) 
                                                     handleSearchClose();

                                                    }else {
                                                        navigate(`/manage-patients/${patientID?._id}/vital-history/${patientID?.patient_id}`, { state: [data[0], true, params?.view, Array.isArray(location.state) ? '' : location.state] }) 
                                                        handleSearchClose();


                                                    }
                                                }}
                                                    className={`py-2.5 px-4 flex items-center text-lg font-normal text-[#fff] 
                                                            rounded-[16px] bg-[#972E4C] hover:bg-[#AB556E] min-w-max
                                                         focus:bg-[#863B50] disabled:bg-[#777C88] ml-2 ${patientTabName==="administrative_notes" || patientTabName==="medical_notes" ? "xl:block hidden" : "block"}`}>
                                                    Vital History
                                                </button>
                                            }
                                            {patientTabName==="device_details" &&
                                                <button type="button" id="welleness_check" data-testid="reading-history"
                                                    onClick={()=>{ 
                                                        if (params.view === undefined) {
                                                            navigate(`/manage-patients/${data?.[0]?._id}/vital-history/device/${data?.[0]?.patient_id}`, { state: [data[0], true, id, Array.isArray(location.state) ? '' : location.state] }) 
                                                            handleSearchClose();
                                                        }else{
                                                            navigate(`/manage-patients/${patientID?._id}/vital-history/device/${patientID?.patient_id}`, { state: [data[0], true, params?.view, Array.isArray(location.state) ? '' : location.state] }) 
                                                            handleSearchClose();

                                                        }
                                                    }}
                                                    className={`py-2.5 px-4 flex items-center text-lg font-normal text-[#fff] 
                                                                rounded-[16px] bg-[#972E4C] hover:bg-[#AB556E] min-w-max
                                                              focus:bg-[#863B50] disabled:bg-[#777C88] ml-2 
                                                              ${patientTabName==="administrative_notes" || patientTabName==="medical_notes" ? "xl:block hidden" : "block"}`}>
                                                    Reading History
                                                </button>
                                            }
                                            <button  type="button" id="welleness_check"
                                                onClick={() => {
                                                    if (params.view === undefined) {
                                                        navigate(`/manage-patients/contact-history/${data[0]?.patient_id}`, { state: { ...(Array.isArray(location.state) ? {} : (location.state || {})), user_id: id, tab_hint: patientTabName } });
                                                        handleSearchClose();
                                                    } else {
                                                        navigate(`/manage-patients/contact-history/${patientID?.patient_id}`, { state: { ...(Array.isArray(location.state) ? {} : (location.state || {})), user_id: params.view, tab_hint: patientTabName } });
                                                        handleSearchClose();

                                                    }
                                                }}
                                                className={`py-2.5 px-4  xl:flex hidden  items-center text-lg font-normal text-[#fff] 
                                        rounded-[16px] bg-[#972E4C] hover:bg-[#AB556E] min-w-max
                                            focus:bg-[#863B50] disabled:bg-[#777C88] ml-4 ${patientTabName==="administrative_notes" || patientTabName==="medical_notes" ? "xl:block hidden" : "block"}`}>
                                                Contact History
                                            </button>
                                            {patientTabName==="monitoring_conditions" &&
                                                <button type="button" 
                                                //     onClick={()=>{ navigate('/manage-patients/monitoring-condition-changes', 
                                                //     { state: [data[0].user_name, true, id] }
                                                // ) }}
                                                    onClick={() => {
                                                    if (params.view === undefined) {
                                                        navigate(`/manage-patients/monitoring-condition-changes`, { state: [data[0].user_name, true, id, Array.isArray(location.state) ? '' : location.state] });
                                                        handleSearchClose();

                                                    } else {
                                                        navigate(`/manage-patients/monitoring-condition-changes`, { state: [patientID?.user_name, true, params?.view, Array.isArray(location.state) ? '' : location.state]});
                                                        handleSearchClose();

                                                    }
                                                }}
                                                    className={`py-2.5 px-4 flex items-center text-lg font-normal text-[#fff] 
                                            rounded-[16px] bg-[#972E4C] hover:bg-[#AB556E] min-w-max
                                                focus:bg-[#863B50] disabled:bg-[#777C88] xl:ml-4 ml-2`}>
                                                    View Change History 
                                                </button>
                                            }
                                            
                                            {patientTabName!=="monitoring_conditions" &&
                                                <button type="button" 
                                                    onClick={()=>{
                                                        if (params.view === undefined) {
                                                        navigate('/manage-patients/activity_history', { state: [data[0].user_name, true, id, { ...(Array.isArray(location.state) ? {} : (location.state || {})), tab_hint: patientTabName }] })
                                                        handleSearchClose();
                                                    }
                                                    else{
                                                        navigate('/manage-patients/activity_history', { state: [patientID?.user_name, true, params?.view, { ...(Array.isArray(location.state) ? {} : (location.state || {})), tab_hint: patientTabName }] })
                                                        handleSearchClose();

                                                    }
                                                    }}
                                                    className={`py-2.5 px-4 flex items-center text-lg font-normal text-[#fff] 
                                            rounded-[16px] bg-[#972E4C] hover:bg-[#AB556E] min-w-max
                                                focus:bg-[#863B50] disabled:bg-[#777C88] xl:ml-4 ml-2 ${userType==='corporate-user'?'hidden':''}`}>
                                                    View Activity Log 
                                                </button>
                                            }
                                            
                                            {(patientTabName==="administrative_notes" && notesCount > 0 ) &&
                                                <button id="icon-export" disabled={exportLoading}  onClick={() => handleExport("administrative-note")}  className="border border-[#972E4C] rounded-[15px] px-[15px] py-[13px] disabled:cursor-not-allowed xl:ml-4 ml-2 min-w-max">
                                                    {exportLoading?
                                                        <div className='flex justify-center items-center'>                       
                                                            <div className="loader ease-linear rounded-full border-t-4 border-[#972E4C] h-5 w-5 spin-animation"></div>                                                        
                                                        </div>
                                                    :<img src="/images/download-red.svg" alt="download-icon" />}
                                                </button>
                                            }
                                            {(patientTabName==="medical_notes" && notesCount > 0) &&
                                                <button id="icon-export" disabled={exportLoading}  onClick={() => handleExport("medical-note")}  className="border border-[#972E4C] rounded-[15px] px-[15px] py-[13px] disabled:cursor-not-allowed xl:ml-4 ml-2 min-w-max">
                                                    {exportLoading?
                                                        <div className='flex justify-center items-center'>                       
                                                            <div className="loader ease-linear rounded-full border-t-4 border-[#972E4C] h-5 w-5 spin-animation"></div>                                                        
                                                        </div>
                                                :<img src="/images/download-red.svg" alt="download-icon" />}
                                                </button>
                                            }
                                            <div className="xl:block hidden">
                                                <button 
                                                    onClick={()=>{handleEditButtonClick('fromView',[location.state,"FromView",id,patientTabName])}} 
                                                    id="edit" type='button' className={`min-w-max px-4 py-2 border border-[#972E4C] h-fit rounded-[16px] flex items-center ml-4`}>
                                                    <span className='w-5'><img src="/images/edit_icon.svg" alt="icon"/></span>
                                                    <span className='pl-2.5 text-lg font-normal text-[#972E4C]'>Edit</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='mx-7 mt-4'>
                                        <div className={`flex justify-between ${isSafari? 'pb-4' : 'pb-2'} overflow-x-auto overflow-y-hidden ${isSafari? 'scrollbar_purple' : 'scrollBar-hidden'} border-b border-[#E7CBD2] w-full mr-6`}>
                                            <button onClick={()=>{handleTabChange('patient')}} className={`px-2.5 pt-2.5 min-w-fit text-base font-semibold ${patientTabName==='patient'?'text-[#972E4C]':'text-[##030E06] '} relative ${patientTabName==='patient'?'patient_tab':''}`}>
                                                Patient Details
                                            </button>
                                            <button id={'monitor_tab'} data-testid={'monitoring_conditions'} onClick={()=>{handleTabChange('monitoring_conditions')}} className={`px-2 pt-2.5 min-w-fit ml-[46px] text-base font-semibold ${patientTabName==='monitoring_conditions'?'text-[#972E4C]':'text-[##030E06] '} relative ${patientTabName==='monitoring_conditions'?'patient_tab':''}`}>
                                                Monitoring Conditions
                                            </button>
                                            <button id={'device_details'} data-testid="device_details" onClick={()=>{handleTabChange('device_details')}} className={`px-2.5 pt-2.5 min-w-fit ml-[46px] text-base font-semibold ${patientTabName==='device_details'?'text-[#972E4C]':'text-[##030E06] '} relative ${patientTabName==='device_details'?'patient_tab':''}`}>
                                                Device Details
                                            </button>
                                            <button id={'administrative_notesTab'} onClick={()=>{handleTabChange('administrative_notes')}} className={`px-2.5 pt-2.5 min-w-fit ml-[46px] text-base font-semibold ${patientTabName==='administrative_notes'?'text-[#972E4C]':'text-[##030E06] '} relative ${patientTabName==='administrative_notes'?'patient_tab':''}`}>
                                                Administrative Notes
                                            </button>
                                            <button id={'medical_notesTab'} onClick={()=>{handleTabChange('medical_notes')}} className={`px-2.5 pt-2.5 min-w-fit ml-[46px] text-base font-semibold ${patientTabName==='medical_notes'?'text-[#972E4C]':'text-[##030E06] '} relative ${patientTabName==='medical_notes'?'patient_tab':''}`}>
                                                Medical Notes
                                            </button>
                                        </div>
                                    </div>
                                    {patientTabName==="patient"&& <ViewPatientDetails 
                                        data={data}

                                    />}
                                    {patientTabName==="administrative_notes"&& <ViewAdministartiveDetails
                                        patient_id={data?.[0]?.patient_id}
                                        notesCount={notesCount}
                                        setNotesCount={setNotesCount}

                                    />}
                                    {patientTabName==="medical_notes" && <ViewMedicalNoteDetails 
                                        patient_id={data?.[0]?.patient_id}
                                        notesCount={notesCount}
                                        setNotesCount={setNotesCount}

                                    />}
                                    {patientTabName==="monitoring_conditions"&&<ViewMonitorConditionTemplate 
                                        isPatient={true} 
                                        viewDataFromPatient={{"data":data?.[0]?.monitoring_template}}
                                    />}
                                    {patientTabName==="device_details"&&<ViewPatientDevices 
                                        patient_id={data?.[0]?.patient_id}
                                    />}
                                    {(helpGuideModel && helpguidestatus==="fulfilled") &&
                                        <HelpGuideModal
                                            setHelpGuideModel={setHelpGuideModel}
                                            pdfUrl={helpguidedata} // Pass the PDF URL to the modal
            />
            }
                                    
                                </div>
                            </div>
                            
                        </motion.div>
                    </div>
                   
                                           
                </>}
            </div>
        </>
    )
}